import React, { useState, useEffect } from "react";
import LoadingSpinner from "../components/LoadingSpinner";
import { useParams } from "react-router-dom";
import { instance as axios } from "../utils/axiosConfig";
import { toast } from "react-toastify";
import FetchingLoadSpinner from "../components/FetchingLoadIndictor";
import PaymentSuccess from "../components/PaymentSuccess";
import SecuredBy from "../components/SecuredBy";

function PayViaLinkPage() {
  const params = useParams();
  const slug = params.slug;

  const [details, setDetails] = useState({
    phone: "",
    amount: "",
  });

  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [initialLoad, setInitialLoad] = useState(false);
  const [linkDetails, setLinkDetails] = useState(null);
  const [paying, setPaying] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [refference, setRefference] = useState("");

  const handleChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value });
  };

  const handlePay = async (e) => {
    e.preventDefault();

    if (!details.phone || !details.amount) {
      return toast.error("all fields required");
    }
    if (details.phone.length !== 10) {
      return toast.error("Invalid phone number");
    }
    if (
      details.phone.substring(0, 2) !== "07" &&
      details.phone.substring(0, 2) !== "01"
    ) {
      return toast.error("Invalid phone number");
    }
    if (Number(details.amount) < 0) {
      return toast.error("Enter realistic amount");
    }
    if (Number(details.amount) < linkDetails?.minimum_amount) {
      return toast.error(
        `${details.amount} is less than ${linkDetails?.minimum_amount}`
      );
    }

    //validation passed
    setPaying(true);
    try {
      const resp = await axios.post("/pay-via-link", {
        phone: details.phone,
        amount: details.amount,
        link_slug: slug,
      });
      setPaying(false);
      setPaymentSuccess(true);
      setRefference(
        resp.data.data.refference || resp.data.data.CheckoutRequestID
      );
      console.log(refference);
      setDetails({
        phone: "",
        amount: "",
      });
    } catch (error) {
      setPaying(false);
      console.log(error);
      if (error.response.data) {
        return toast.warning(`${error.response.data}`);
      }
      toast.error(`Something wrong happened`);
    }
  };

  const fetchLinkDetails = async () => {
    setInitialLoad(true);
    try {
      const resp = await axios.get(`/link-details/${slug}`);
      // console.log(resp.data);
      if (resp.data.status !== "ACTIVE") {
        setError(true);
        setErrorMsg("This link is nolonger active");
        setInitialLoad(false);
        return;
      }
      setLinkDetails(resp.data);
      setInitialLoad(false);
    } catch (error) {
      setInitialLoad(false);
      console.log(error);
      if (error.response.data) {
        setError(true);
        setErrorMsg(error.response.data);
      }
    }
  };

  useEffect(() => {
    fetchLinkDetails();
  }, []);
  return (
    <div className="bg-yellow-50 ">
      {initialLoad ? (
        <LoadingSpinner />
      ) : (
        <>
          <div className="absolute w-full flex items-center justify-center mt-32">
            {error ? (
              <img
                className="w-40 h-40 rounded-full"
                alt="avator"
                src="https://us.123rf.com/450wm/koya79/koya791910/koya79191001162/132300946-rich-arab-emoji-isolated-on-white-background-dollar-eyes-arabian-emoticon-3d-rendering.jpg?ver=6"
              />
            ) : linkDetails?.avator ? (
              <img
                className="w-40 h-40 rounded-full"
                alt="avator"
                src={linkDetails?.avator}
              />
            ) : (
              <div className="relative inline-flex items-center justify-center w-40 h-40 overflow-hidden bg-gray-100 rounded-full">
                <span className="font-medium text-gray-600 text-center">
                  {linkDetails?.title.split(" ")[0]}
                </span>
              </div>
            )}
          </div>
          <img
            src="https://tinypesa.com/img/checkout/26_CHRISTMAS.png"
            alt=""
            className="w-full h-48"
          />
          {error ? (
            <section className="mt-20 m-auto bg-yellow-50 xl:container px-12 sm:px-0 mx-auto">
              <div className="mx-auto h-full sm:w-max relative">
                <div className="m-auto  py-10">
                  <h1 className="text-xl text-center my-10">{errorMsg}</h1>
                </div>
              </div>
            </section>
          ) : (
            <section className="mt-20 m-auto bg-yellow-50 xl:container px-12 sm:px-0 mx-auto">
              <div className="mx-auto h-full sm:w-max relative">
                <div className="m-auto  py-10">
                  <h1 className="text-center mb-4">{linkDetails?.title}</h1>
                  <h1 className="text-center mb-4">
                    {linkDetails?.description}
                  </h1>
                  {paying ? (
                    <FetchingLoadSpinner />
                  ) : paymentSuccess ? (
                    <PaymentSuccess
                      refference={refference}
                      title={linkDetails?.title}
                      func={() => setPaymentSuccess(false)}
                    />
                  ) : (
                    <form onSubmit={handlePay}>
                      <div className="mb-6">
                        <label
                          htmlFor="name"
                          className="block mb-2 text-sm font-medium text-gray-900 "
                        >
                          Phone Number
                        </label>
                        <input
                          type="tel"
                          name="phone"
                          value={details.phone}
                          onChange={handleChange}
                          className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
                          placeholder="07.. or 01.. "
                          required
                        />
                      </div>
                      <div className="mb-6">
                        <label
                          htmlFor="name"
                          className="block mb-2 text-sm font-medium text-gray-900 "
                        >
                          Amount
                        </label>
                        <input
                          type="number"
                          name="amount"
                          value={details.amount}
                          onChange={handleChange}
                          className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
                          placeholder="Eg 10 , 200 "
                          required
                        />
                        {Number(linkDetails?.minimum_amount) > 0 && (
                          <p className="text-sm my-2 text-gray-700">
                            Link minimum amount is {linkDetails?.minimum_amount}
                          </p>
                        )}
                      </div>
                      <button
                        type="submit"
                        className="text-yellow-900 bg-yellow-400 opacity-80 hover:bg-yellow-300 focus:ring-3 focus:outline-none focus:ring-yellow-800 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center"
                      >
                        Pay Now
                      </button>
                    </form>
                  )}
                </div>
              </div>
            </section>
          )}
          <SecuredBy />
        </>
      )}
    </div>
  );
}

export default PayViaLinkPage;
